$(document).ready(function () {

    let header_height_from_top = $('.section-header').offset().top;
    $('html').css('--header-top-position',(header_height_from_top + 'px'));

    function window_inner_height(){
        $('html').css('--window-height',($(window).height())+'px');
    }
    window_inner_height();
    $(window).on('resize',function(){
        window_inner_height();
    });

    function isInViewport(element) {
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    /* ------------ Announcement bar */
    if($('#announcement-bar').length > 0){
        $('#announcement-bar-close').click(function(){
            $('#announcement-bar').hide();
            $('html').css('--header-top-position',('0px'));
        });
    }
    /* ------------ Announcement bar */

    /* ------------ Header */
    $('.header_megamenu .megamenu_link').hover(
        function () {
            var info = $(this).data('info-target');
            $(this).parents('.header_megamenu').addClass('is-link-hover');
            $(this).parents('.header_megamenu').find('.megamenu_links_info-block[data-info-for="'+ info +'"]').addClass('active').siblings('.megamenu_links_info-block').removeClass('active');

            $(this).parents('.header_megamenu').find('.megamenu_links_info-blocks').height($(this).parents('.header_megamenu').find('.megamenu_links_info-block.active').innerHeight());

            $(this).parents('.header_megamenu').find('.media-block[data-info-for="'+ info +'"]').addClass('active').siblings('.media-block').removeClass('active');
        },
        function () {
            $(this).parents('.header_megamenu').removeClass('is-link-hover');
            $(this).parents('.header_megamenu').find('.media-block').eq(0).addClass('active').siblings('.media-block').removeClass('active');
            $(this).parents('.header_megamenu').find('.megamenu_links_info-block').removeClass('active');
            setTimeout(function(){
                $('.header_megamenu:not(.is-link-hover)').find('.megamenu_links_info-blocks').height(0);
            },450);
        }
    );

    // $('.menu-drawer__megamenu .menu-drawer__menu .link').click(function(e){
    //     e.preventDefault();
    //     var info = $(this).data('info-target');
    //     $(this).addClass('is-active').parents('li').siblings('li').find('.is-active').removeClass('is-active');
    //     $(this).parents('.menu-drawer__megamenu').addClass('is-link-active');
    //     $(this).parents('.menu-drawer__megamenu').find('.media-block[data-info-for="'+ info +'"]').addClass('active').siblings('.media-block').removeClass('active');
    // });
    
    $('.menu-drawer__megamenu .menu-drawer__close-button,#Details-menu-drawer-container .header__icon--menu').click(function(e){
        $('.menu-drawer__megamenu .link').removeClass('is-active')
        $('.menu-drawer__megamenu').removeClass('is-link-active');
        $('.menu-drawer__megamenu').find('.media-block').eq(0).addClass('active').siblings('.media-block').removeClass('active');
    })
    /* ------------ Header */

    // ------------------ Text with bg slider
    var text_with_bg_slider = new Swiper('.text-with-bg-slider .text-with-bg-slider-row', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 1500,
        },
        loop: true,
        speed: 1000
    });
    // ------------------ Text with bg slider


    // ------------------ Text with images slider
    if($('.text-with-image-slider').length > 0){
        var text_with_image_slider_thumb = new Swiper('.text-with-image-slider .media-slider-thumbs', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: '.text-with-image-slider .media-slider-thumbs .swiper-button-next',
                prevEl: '.text-with-image-slider .media-slider-thumbs .swiper-button-prev',
            },
        });

        var text_with_image_slider_thumb_content = new Swiper('.text-with-image-slider .content-slider-row', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true 
            },
            speed: 800,
            allowTouchMove: false,
            simulateTouch: false,
            loop: true,
            autoHeight: true,
        });

        var text_with_image_slider_main = new Swiper('.text-with-image-slider .media-slider-main', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            mousewheel: {
                forceToAxis: true
            },
            speed: 1000,
            loop: true,
            navigation: {
                nextEl: '.text-with-image-slider .media-slider-main .swiper-button-next',
                prevEl: '.text-with-image-slider .media-slider-main .swiper-button-prev',
            },
            pagination: {
                el: '.text-with-image-slider .media-slider-main .swiper-pagination',
                clickable: true,
            },
            thumbs: {
                swiper: text_with_image_slider_thumb
            },
            on: {
                slideChange: function () {
                    text_with_image_slider_thumb_content.slideToLoop(this.realIndex);
                    text_with_image_slider_thumb.update();
                }
            }
        });
    }
    // ------------------ Text with images slider


    // ------------  Faqs
    if($('[data-faq-block]').length > 0){
        $('[data-faq-toggle]').click(function(){
            if ($(this).parents('[data-faqs-main="one-at-time"]').length > 0) {
                $(this).parents('[data-faq-block]').siblings('[data-faq-block].active').removeClass('active').find('[data-faq-content]').slideUp();
            }
            $(this).next('[data-faq-content]').slideToggle();
            $(this).parents('[data-faq-block]').toggleClass('active');
        });
    }
    // ------------  Faqs


    // ------------  custom select
    $(document).on('click', '.custom_select_label', function (e) {
        e.stopPropagation();
        $('.custom_select_box').not($(this).closest('.custom_select_box')).removeClass('open');
        $(this).closest('.custom_select_box').toggleClass('open');
    });
    $(document).on('change', '.custom_select_box .custom_select_option input', function () {
        const text = $(this).siblings('span').text();
        const wrap = $(this).closest('.custom_select_box');

        wrap.find('.custom_select_label').text(text);
        wrap.removeClass('open');
    });
    $(document).on('click', function () {
        $('.custom_select_box').removeClass('open');
    });
    // ------------  custom select
    
    // ------------  Main Policy page

    if($('#main-policy-nav').length > 0){
        function checkSticky($el,wrap_height) {
            const rect = $el[0].getBoundingClientRect().top + (wrap_height / 2);
            const isSticky = rect <= 0;
            $('#main-policy-nav').toggleClass('is-sticky', isSticky);
            if(isSticky){
                $('.main-policy .main-policy-nav-wrap').css('padding-bottom',wrap_height+'px');
            }else{
                $('.main-policy .main-policy-nav-wrap').css('padding-bottom','0');
                $('#main-policy-nav').removeClass('open-navs');
                $('#main-policy-nav .main-policy-nav-links').hide();
            }
        }

        const main_policy_nav = $('.main-policy .main-policy-nav-wrap');
        const main_policy_link_height = $('#main-policy-nav').innerHeight();
        $(window).on('scroll resize', function () {
            if ($(window).width() < 750) {
                checkSticky(main_policy_nav,main_policy_link_height);
            }
        });
        if ($(window).width() < 750) {
            checkSticky(main_policy_nav,main_policy_link_height);
        }

        $('#main-policy-nav .main-policy-nav-head').click(function(e){
            e.stopPropagation();
            if($('#main-policy-nav').hasClass('is-sticky')){
                $(this).parents('#main-policy-nav').toggleClass('open-navs');
                $(this).next('.main-policy-nav-links').slideToggle();
            }
        });
        $('#main-policy-nav .main-policy-nav-links a').click(function(){
            if($('#main-policy-nav').hasClass('is-sticky')){
                $(this).parents('#main-policy-nav').removeClass('open-navs');
                $(this).parents('.main-policy-nav-links').slideUp();
            }
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest('#main-policy-nav').length) {
                $('#main-policy-nav.is-sticky').removeClass('open-navs');
                $('#main-policy-nav.is-sticky .main-policy-nav-links').hide();
            }
        });
    }
    // ------------  Main Policy page

    // ------------  Product Card Media
    if($('.product-card-wrapper').length > 0){

        $('.product-card-wrapper').each(function () {
            var $card = $(this);
            var product_card_media_slider = new Swiper($(this).find('.product-card-media-slider')[0],{
                slidesPerView: 1,
                spaceBetween: 7,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 800,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false // IMPORTANT
                },
                loop: true,
                allowTouchMove: false,
                pagination: {
                    el: $(this).find('.product-card-media-slider .swiper-pagination')[0],
                    clickable: true,
                },
                nested: true
            });

            $card.on('mouseenter', function () {
                product_card_media_slider.autoplay.start();
            });
            $card.on('mouseleave', function () {
                product_card_media_slider.autoplay.stop();
                product_card_media_slider.slideToLoop(0); // optional: reset to first slide
            });
            product_card_media_slider.autoplay.stop();
        });
    }
    // ------------  Product Card Media


    // ------------  Treatment Menu
    if($('.treatment-menu').length){
        $('.treatment-menu').css('--menu-bar-height',$('.treatment-menu .treatment-menu-sec-head').innerHeight()+'px');
    }
    // ------------  Treatment Menu

    // ------------  Facet
    if($('#FacetFiltersForm').length > 0){
        $(document).on('click','.facets_details-block-title',function(e){
            e.preventDefault();
            $(this).parents('.facets_details-block').toggleClass('active').siblings('.facets_details-block').removeClass('active');
            if($(window).width() < 990){
                $(this).parents('.facets_details-block').siblings('.facets_details-block').find('.facets_details-block-info').slideUp();
                $(this).next('.facets_details-block-info').slideToggle();
            }
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.facets_details-block').length && $(window).width() > 989) {
                $('.facets_details-block').removeClass('active');
            }
        });
        $(document).on('click','.mobile-facets__open-wrapper', function (e) {
            $(this).parents('.mobile-facets__wrapper').toggleClass('active');
            $('#FacetFiltersFormMobile').slideToggle()
            if(!$(this).hasClass('active')){
                $('#FacetFiltersFormMobile .facets_details-block').removeClass('active');
                $('#FacetFiltersFormMobile .facets_details-block-info').slideUp();
            }
        });

        $(document).on('click','#facet-filters__label-toggle',function(e){
            e.preventDefault();
            $(this).parents('.facet-filters__field').toggleClass('active');
            $(this).next('.facet_sort_radio-wrap').slideToggle();
        });
    }
    // ------------  Facet


    // ------------ Blog Facet
    if($('#blog-sort-bar').length > 0){
        $(document).on('click','#blog-sort-bar .blog-toggle-menu-head',function(e){
            e.preventDefault();
            $(this).parents('.blog-toggle-menu').toggleClass('active').siblings('.blog-toggle-menu').removeClass('active');
            if($(window).width() < 990){
                $(this).parents('.blog-toggle-menu').siblings('.blog-toggle-menu').find('.blog-toggle-menu-info').slideUp();
                $(this).next('.blog-toggle-menu-info').slideToggle();
            }
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.facets_details-block').length && $(window).width() > 989) {
                $('.facets_details-block').removeClass('active');
            }
        });
    }
    // ------------ Blog Facet

    // ------------  Product
    if($('#product__main-media').length > 0){
        var product_thumb_media = new Swiper("#product__thumb-media", {
            slidesPerView: 6,
            spaceBetween: 8,
            loop: true,
            navigation: {
                nextEl: '#product__thumb-media .swiper-button-next',
                prevEl: '#product__thumb-media .swiper-button-prev',
            },
            breakpoints: {
                750: {
                    spaceBetween: 10
                }
            }
        });

        var product_main_media = new Swiper("#product__main-media", {
            slidesPerView: 1,
            autoHeight: false,
            loop: true,
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: "#product__main-media .swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: '#product__main-media .swiper-button-next',
                prevEl: '#product__main-media .swiper-button-prev',
            },
            thumbs: {
                swiper: product_thumb_media,
            },
        });
    }
    // ------------  Product


    // ------------  Copy Link
    $('body').on('click', '.copy-link', function (e) {
        e.preventDefault();
        navigator.clipboard.writeText($(this).data('link'));
        alert("Link copied!");
    });
    // ------------  Copy Link


    // ------------  Step in to
    if($('.step-in-to').length > 0){
        // $('.step-in-to .step-in-to-content-slider').height($('.step-in-to-content').innerHeight());
        
        var step_in_to_media = new Swiper('.step-in-to .media-block-slider', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 2000,
            slidesPerView: 1,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            allowTouchMove: false,
            simulateTouch: false,
        });

        var step_in_to = new Swiper('.step-in-to .step-in-to-content-slider',{
            direction: "vertical",
            loop: true,
            slidesPerView: 1,
            spaceBetween: 12,
            centeredSlides: true,
            autoHeight: true,
            observer: true,
            observeParents: true,
            spaceBetween: 0,
            allowTouchMove: false,
            simulateTouch: false,
            speed: 2000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                waitForTransition: false
            },
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
                sensitivity: 1,
            },
            touchReleaseOnEdges: true,
            pagination: {
                el: '.step-in-to .step-in-to-content-pagination',
                clickable: true,
            },
            thumbs: {
                swiper: step_in_to_media
            },
            breakpoints: {
                750: {
                    spaceBetween: 50
                }
            },
            on: {
                init: function () {
                    setSwiperMaxHeight();
                    updateProgress(this);
                },
                slideChange: function(){
                    updateProgress(this);
                }
            }
        });
        function updateProgress(swiper){
            var total = swiper.slides.length - 1;
            var active = swiper.realIndex;
            var percent = (active / total) * 100;

            $('.step-in-to .step-in-to-content-pagination').css('--progress-width', percent + '%');
            $('.step-in-to .step-in-to-content-pagination .swiper-pagination-bullet').each(function(index){
                if(index <= (active - 1)){
                    $(this).addClass('completed');
                }else{
                    $(this).removeClass('completed');
                }

                (index == active)?$('.step-in-to .step-in-to-content-pagination').addClass('last-slide-active'):$('.step-in-to .step-in-to-content-pagination').removeClass('last-slide-active')
            });
        }

        function setSwiperMaxHeight() {
            var maxHeight = 0;
            $('.step-in-to-content-slider .block-content').each(function () {
                var thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });
            $('.step-in-to-content-slider').height(maxHeight);
        }
    }
    // ------------  Step in to


    // ------------  Core Pillars
    if($('.core-pillars').length > 0){
        function core_pillars_icon(){
            var icon_height = $('.core-pillars .core-pillars-block').eq(0).find('.core-pillars-icon').innerHeight();
            var heading_height = $('.core-pillars .sec-head').innerHeight();
            $('.core-pillars').css('--icon-height', icon_height+'px');
            $('.core-pillars').css('--heading-height', heading_height+'px');
        }
        core_pillars_icon()
        $(window).on('resize',function(){
            core_pillars_icon();
        });

        var core_icons_length = $('.core-pillars .core-pillars-row .core-pillars-block .core-pillars-icon').length;
        $('.core-pillars .core-pillars-row .core-pillars-block .core-pillars-icon').each(function(){
            let $icon = $(this);
            let dot_length = $(this).find('.dot').length;
            var interation = 1.8*dot_length * 1000;
            function runAnimation(){
                $icon.find('.dot').each(function(i, a){
                    $(this).addClass('active');
                    if(i === dot_length - 1){
                        setTimeout(function(){
                            $icon.addClass('blink');
                            $icon.find('.dot').removeClass('active');
                            setTimeout(function(){
                                $icon.removeClass('blink');
                                setTimeout(runAnimation, 1500);
                            },2000);

                        },interation);
                    }
                });
            }
            runAnimation();
        });
    }
    // ------------  Core Pillars

    // Footer Form
    if (window.location.href.indexOf('?customer_posted=true#ContactFooter') > 0) {
        $('html, body').animate({
        scrollTop: $("#ContactFooter").offset().top - 60
        }, 2000);
    }
    // Footer END Form
    
    
    
    $(window).scroll(function() {
        var currentScroll = $(this).scrollTop();
        var lastScroll = $(this).data('lastScroll') || 0;

        if (currentScroll < lastScroll && currentScroll > 0) {
            $('.header-wrapper').addClass('scrolled-up');
        } else {
            $('.header-wrapper').removeClass('scrolled-up');
        }

        $(this).data('lastScroll', currentScroll);
    });


    $('a[href]').each(function() {
    var linkHost = this.hostname;

    if (linkHost && linkHost !== window.location.hostname) {
        $(this).attr({
        target: '_blank',
        rel: 'noopener noreferrer'
        });
    }
    });

});